<template>
  <div v-if="pageCount > 1">
    <div v-if="pageCount > 1" class="da-pagination">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: firstPage }">
          <a
            class="page-link"
            href="#"
            arial-label="previous"
            @click.prevent="firstPage ? '' : localValue--"
          >
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li
          v-for="page in pageCount"
          class="page-item"
          :class="{ active: page === value }"
        >
          <a class="page-link" @click.prevent="localValue = page" href="#"
            >{{ page }}<span class="sr-only">(current)</span></a
          >
        </li>
        <li class="page-item" :class="{ disabled: lastPage }">
          <a
            class="page-link"
            href="#"
            @click.prevent="lastPage ? '' : localValue++"
          >
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </a>
        </li>
      </ul>
      <!--//pagination-->
    </div>
    <!--//pagination-container-->
  </div>
</template>

<script>
export default {
  name: "da-pagination",

  data: () => ({}),

  props: {
    value: Number,
    itemsCount: Number,
    items: Array,
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    pageCount() {
      if (this.itemsCount) {
        return Math.floor(this.itemsCount / this.items.length);
      }
    },
    firstPage() {
      return this.value <= 1;
    },
    lastPage() {
      return this.value >= this.pageCount;
    },
  },
};
</script>

<style scoped lang="scss">
.da-pagination {
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
